import React from 'react';
import { useParams, withRouter } from 'react-router-dom';

import { SelectedEventQueryRoute, SelectedEventQueryView } from '@atlas/core';

export const SelectedEventQueryRouteWrapper = withRouter(SelectedEventQueryRoute);
export const SelectedEventQueryViewWrapper = withRouter(SelectedEventQueryView);

export const SelectedProviderWrapper = ({ Component, children }) => {
  const routerParams = useParams();

  const propsParams = (Component.params || []).reduce((acc, next) => {
    const newParam = routerParams[next];
    if (newParam) return { ...acc, [next]: newParam };
    return acc;
  }, {});

  return <Component {...propsParams}>{children}</Component>;
};
